import { Injectable, inject } from '@angular/core';
import { CanActivateFn, UrlTree } from '@angular/router';
import { EndpointKeys, UserSessionService } from '@com-delta-idp/mnx-oauth';
import { AppConfigService, IDP_APPS } from '@com-delta-idp/mnx-utils';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {
  private userService = inject(UserSessionService);
  private appConfig = inject(AppConfigService);

  canActivate(): Observable<boolean | UrlTree> {
    return this.userService.getUserSession().pipe(
      map((response) => {
        if (response && response.smNumber) {
          return true;
        } else {
          return this.checkLocalHostRoute();
        }
      }),
      catchError(() => {
        this.redirect();
        return of(false);
      })
    );
  }

  checkLocalHostRoute(): boolean {
    if (window.location.hostname === 'localhost') {
      return true;
    } else {
      this.redirect();
      return false;
    }
  }

  private redirect() {
    this.appConfig
      .getConfigValue(IDP_APPS.COMMON, EndpointKeys['LOGIN_URL'])
      .subscribe((loginUrl) => {
        const url = `${window.location.origin}${loginUrl}?refreshURL=${window.location.href}`;
        window.open(url, '_self');
      })
      .unsubscribe();
  }
}

export const AuthGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  return inject(PermissionService).canActivate();
};
